module.exports = __webpack_public_path__ + "static/media/itinerary.9d72be61.jpg";